function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as t, Fragment as c, jsxs as f } from "react/jsx-runtime";
import m from "classnames";
import { container as g, badgeNumber as b, badgeWithChildren as a, badgeBigNumber as l, badge as p } from "./badge.css-mistica.js";
import { getPrefixedDataAttributes as u } from "./utils/dom.js";
import { Text1 as x } from "./text.js";
import { useTheme as N } from "./hooks.js";
import { vars as B } from "./skins/skin-contract.css-mistica.js";
const h = (param)=>{
    let { children: r , value: e , right: s , top: i , dataAttributes: n  } = param;
    const { textPresets: d  } = N();
    if (r && e === 0) return /* @__PURE__ */ t(c, {
        children: r
    });
    if (e === 0) return null;
    const o = e && e > 9;
    return /* @__PURE__ */ f("div", _object_spread_props(_object_spread({
        className: g
    }, u(n, "Badge")), {
        children: [
            e ? /* @__PURE__ */ t("div", {
                role: "presentation",
                "aria-hidden": "true",
                className: m(b, {
                    [a]: !!r,
                    [l]: o
                }),
                style: {
                    right: s,
                    top: i
                },
                children: /* @__PURE__ */ t(x, {
                    forceMobileSizes: !0,
                    weight: d.indicator.weight,
                    color: B.colors.textPrimaryInverse,
                    children: o ? "+9" : e
                })
            }) : /* @__PURE__ */ t("div", {
                style: {
                    right: s,
                    top: i
                },
                className: m(p, {
                    [a]: !!r
                })
            }),
            r
        ]
    }));
}, C = h;
export { C as default };
